import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../i18n/LangContext";

const KEY = "ah_cookie_consent";
export const COOKIE_EVENT = "ah:cookie-preferences";

const applyConsent = (choice) => {
  const ph = window.posthog;
  if (!ph) return;
  if (choice === "accepted") ph.opt_in_capturing?.();
  else ph.opt_out_capturing?.();
};

export const openCookiePreferences = () => window.dispatchEvent(new Event(COOKIE_EVENT));

export const CookieBanner = () => {
  const { t } = useLang();
  const c = t.cookies;
  const [open, setOpen] = useState(false);
  const isAdmin = useLocation().pathname.startsWith("/admin");

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved) applyConsent(saved);
    else setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener(COOKIE_EVENT, reopen);
    return () => window.removeEventListener(COOKIE_EVENT, reopen);
  }, []);

  const choose = (choice) => {
    localStorage.setItem(KEY, choice);
    applyConsent(choice);
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && !isAdmin && (
        <motion.aside
          role="dialog"
          aria-label={c.title}
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.6, ease: [0.7, 0, 0.2, 1] }}
          className="fixed bottom-5 left-5 right-5 sm:right-auto sm:max-w-sm z-[90] border border-line bg-[rgba(19,18,16,0.82)] backdrop-blur-xl p-6 text-[var(--bone)] shadow-2xl"
        >
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold">{c.over}</p>
          <p className="mt-3 font-display text-2xl leading-tight">{c.title}</p>
          <p className="mt-3 text-sm text-stone leading-relaxed">
            {c.body}{" "}
            <Link to="/confidentialite" data-testid="cookie-policy-link" className="link-underline text-[var(--bone)]">{c.more}</Link>
          </p>
          <div className="mt-5 flex items-center gap-3">
            <button data-testid="cookie-accept-btn" onClick={() => choose("accepted")} className="rounded-full bg-[var(--gold)] text-[var(--ink)] px-5 py-2 text-sm font-semibold hover:bg-[var(--gold-2)] transition-colors duration-300">
              {c.accept}
            </button>
            <button data-testid="cookie-refuse-btn" onClick={() => choose("refused")} className="rounded-full border border-line px-5 py-2 text-sm hover:border-[var(--bone)] transition-colors duration-300">
              {c.refuse}
            </button>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};
